import {createApp} from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import VueAxios from 'vue-axios'
import moment from 'moment'
import {reverseMode, StatiSottoprogetto, StatiSottoprogettoToLabel} from "@/types";
import TopNavigationBar from "@/components/TopNavigationBar.vue";
import Topbar from "@/components/Topbar.vue";
import Environment from "@/Environment";
import VueMultiselect from "vue-multiselect";
import * as Sentry from "@sentry/vue";
import {library} from "@fortawesome/fontawesome-svg-core";
import {faStar as faStarS} from "@fortawesome/free-solid-svg-icons";
import {faStar as faStarR} from "@fortawesome/free-regular-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";
import env from "@/Environment";
import filesManager from "@/api/File";

library.add(faStarS, faStarR);

// @ts-ignore
Number.prototype.toLocaleValueString = function (mindecimal = 2, maxdecimal) {
    return this.toLocaleString('it', {
        minimumIntegerDigits: 1,
        minimumFractionDigits: mindecimal,
        maximumFractionDigits: maxdecimal,
        useGrouping: true
    });
};

// @ts-ignore
Number.prototype.toCurrencyString = function () {
    return this.toLocaleString('it', {
        minimumIntegerDigits: 1,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
        useGrouping: true
    });
};

store.dispatch('init').catch(() => {
}).finally(() => {
    router.beforeEach((to, from, next) => {
        const next_route = localStorage.getItem('next_route')
        const permission = to.meta.permission ?? 'access crm'
        if (next_route) {
            localStorage.removeItem('next_route')
            next(next_route)
        } else if (to.name !== 'Login' && !to.meta.public && !store.getters.isAuthenticated) {
            next({name: 'Login'})
        } else if (store.getters.isAuthenticated && !store.getters.hasPermission(permission) && to.name !== 'PermissionDenied') {
            // se non ho accesso al crm allo redirigo
            next({name: 'PermissionDenied'})
        } else {
            next()
        }
    })

    const app = createApp(App).use(store).use(router).use(VueAxios, axios)
        .component("font-awesome-icon", FontAwesomeIcon)
        .component('TopNavigationBar', TopNavigationBar)
        .component('Topbar', Topbar)
        .component('VueMultiselect', VueMultiselect)
    app.provide('axios', app.config.globalProperties.axios)
    app.provide('getLabelStato', (stato: any) => {
        const rec = reverseMode.get(stato?.PD1E_CODICE)
        // @ts-ignore
        return StatiSottoprogettoToLabel[rec]
    })
    app.provide('downloadFile', (f: string | number, name:string) => {
        return filesManager.download(f).then(response => {
            const blob = new Blob([response.data], {type: response.headers['content-type']})
            const url = window.URL.createObjectURL(blob)
            const a = document.createElement('a')
            a.href = url
            a.download = response.headers['content-disposition'].split('filename=')[1].replace(/"/gi, "")
            document.body.appendChild(a)
            a.click()
            a.remove()
            window.URL.revokeObjectURL(url)
        })
    })
    app.provide('getColoreStato', (stato: any) => {
        switch (stato?.PD1E_CODICE) {
            case StatiSottoprogetto.OFFERTA:
                return 'bg-next-stato-0'
            case StatiSottoprogetto.OFFERTA_INVIATA:
                return 'bg-next-stato-1'
            case StatiSottoprogetto.OFFERTA_NON_CONFERMATA:
                return 'bg-next-stato-2'
            case StatiSottoprogetto.OFFERTA_NON_CONFERMATA_DA_CHIUDERE:
                return 'bg-next-stato-3'
            case StatiSottoprogetto.RICHIESTA_APERTURA:
                return 'bg-next-stato-4'
            case StatiSottoprogetto.APERTO:
                return 'bg-next-stato-5'
            case StatiSottoprogetto.CONSUNTIVAZIONE_INVIATA:
                return 'bg-next-stato-6'
            case StatiSottoprogetto.CHIUSURA_DA_ODA:
                return 'bg-next-stato-7'
            case StatiSottoprogetto.CHIUSO_CONTABILMENTE:
                return 'bg-next-stato-8'
            case StatiSottoprogetto.ERRATA:
                return 'bg-next-stato-2'
        }
        return 'bg-next-stato-0'
    })
    app.config.globalProperties.$filters = {
        toDownloadFile(f: string | null) {
            if (f) {
                return `${env.backendUrl}/file/${f}/download`
            }
            return ''
        },
        toDate(value: string | null) {
            if (value) {
                return moment(value).format('DD/MM/YYYY')
            }
            return ''
        },
        toTime(value: string | null) {
            if (value) {
                return moment(value).format('HH:mm')
            }
            return ''
        },
        toDateTime(value: string | null) {
            if (value) {
                return moment(value).format('DD/MM/YYYY HH:mm')
            }
            return ''
        },
        toCurrency(value: number | string | null) {
            if (value) {
                //@ts-ignore
                return parseFloat(value).toLocaleString('it-IT', {minimumFractionDigits: 2, maximumFractionDigits: 2})
            }
            return '0'
        },
        toFormat(value: number | string | null, minimumFractionDigits = 2, maximumFractionDigits = 2) {
            if (value) {
                //@ts-ignore
                return parseFloat(value).toLocaleString('it-IT', {minimumFractionDigits, maximumFractionDigits})
            }
            return '0'
        },
        toEuroCurrency(value: number | string | null) {
            return `${this.toCurrency(value)} €`
        },
        toSiNo(value: number | string | null) {
            if (value) {
                return 'Sì'
            }
            return 'No'
        }
    }

    if (!Environment.isDev) {
        Sentry.init({
            app,
            dsn: "https://ab5eca5b39d70ea131ab0de6c42ecbd6@o142051.ingest.sentry.io/4506077810982912",
            integrations: [
                new Sentry.BrowserTracing({
                    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
                    tracePropagationTargets: ["localhost", /^.*\.nextgroup.eu\/app/],
                    routingInstrumentation: Sentry.vueRouterInstrumentation(router),
                }),
                new Sentry.Replay(),
            ],
            // Performance Monitoring
            tracesSampleRate: 1.0, // Capture 100% of the transactions
            // Session Replay
            replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
            replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
        });
    }

    app.mount('#app')
})
